// extracted by mini-css-extract-plugin
module.exports = {"content":"f5b5da"};